import axiosClient from '../api/AxiosConfig';

export const PromotionService = {
  CreatePromotion: async (data) => {
    return (await axiosClient.post('/promotion', data)).data;
  },
  EditPromotion: async (id, data) => {
    return (await axiosClient.put(`/promotion/private/${id}`, data)).data;
  },
  GetPromotion: async (filter) => {
    return (await axiosClient.get('/promotion/private', { params: filter })).data;
  },
  DisablePromotion: async (id) => {
    return (await axiosClient.patch(`/promotion/private/${id}/disable`)).data;
  },
  EnablePromotion: async (id) => {
    return (await axiosClient.patch(`/promotion/private/${id}/enable`)).data;
  },
  DeletePromotion: async (id) => {
    return (await axiosClient.delete(`/promotion/private/${id}`)).data;
  },
  GetPromotionBySlug: async (slug) => {
    return (await axiosClient.get(`/promotion/private/${slug}`)).data;
  },
};
